import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "NivelAcademicoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "SemestrePage",
            ss: ss,
            ajax: {
                "url": ss.indexNivelAcademico(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'NivelAcademico', name: 'NivelAcademico', title: 'Nivel Académico' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],

            nivelacademicos: [],
            nivelacademico: {},

            isLoading: false,
            errorBag: {},
            auth : null,
        };
    },
    methods: {
        newNivelAcademico() {
            this.carrera = {};
            this.$refs['frm-nivelacademico'].show();
        },
        showNivelAcademico(id) {
            this.isLoading=true;
            this.ss.showNivelAcademico(id).then(
                (result) => {
                    let response = result.data;
                    this.nivelacademico = response.data;
                    this.$refs['view-nivelacademico'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editNivelAcademico() {
            this.$refs['frm-nivelacademico'].show();
            this.$refs['view-nivelacademico'].hide();
        },
        cancelNivelAcademico() {
            if (this.carrera.id) {
                this.$refs['view-nivelacademico'].show();
            }
            this.$refs['frm-nivelacademico'].hide();
        },
        saveNivelAcademico() {
            this.ss.storeNivelAcademico(this.nivelacademico).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-nivelacademico'].hide();
                    this.$refs['datatable-nivelacademico'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },

        saga() {
         
            this.ss.listarNAcademico().then(
                (result) => {
                    let response = result.data;
                    this.nivelacademico = response.data;
                    location.reload();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        deleteNivelAcademico() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttons: true,
                dangerMode: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                        this.ss.destroyNivelAcademico(this.nivelacademico)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-nivelacademico'].hide();
                                this.$refs['datatable-nivelacademico'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-NivelAcademico').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showNivelAcademico(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario'));
        if (!usuario) {
          this.$router.push('/Login');
        }else{
            this.auth = usuario;
        }
    }
};
